import { useEffect, useState } from "react"
import { Tooltip } from "react-tooltip"
import ArrowBackButton from "../../../components/button/ArrowBackButton"
import { Select } from "antd"
import { useParams } from "react-router-dom"
import useCalibration from "./useCalibration"
import ActionButtonGradient from "../../../components/button/ActionButtonGradient"

const CalibrationForm = () => {
    const params = useParams()
    const [isUpdate, setIsUpdate] = useState(false)
    const {
        getAllUsers,
        employeeSelect,
        allUsers,
        getProjectPhases,
        projectPhases,
        payload,
        handleSelectedEmployee,
        handleData,
        getCalibrationData,
        employee,
        onSubmit,
        handleChangeActualScore,
        actualScore,
        getActualScore,
        handleDataActualRating,
        handleDataY1Rating,
        handleDataY2Rating,
        isSaving,
        allSpmo,
    } = useCalibration()

    useEffect(() => {
        getAllUsers()
        if (params.project_id) {
            getProjectPhases(params.project_id)
            if (params.employee_id) {
                setIsUpdate(true)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.project_id, params.employee_id])

    useEffect(() => {
        if (params.project_id && params.employee_id && projectPhases.length > 0 ) {
            getCalibrationData(params.project_id, params.employee_id, projectPhases)
            getActualScore(params.project_id, params.employee_id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.project_id, params.employee_id, projectPhases])

    const [ratingChoices, setRatingChoices] = useState([
        {label: 'A+',value: 'A+'},
        {label: 'A',value: 'A'},
        {label: 'B+',value: 'B+'},
        {label: 'B',value: 'B'},
        {label: 'C',value: 'C'},
        {label: 'D',value: 'D'},
    ])

    const handleScoreInput = (e) => {
        const value = e.target.value
        // Allow only numbers and one decimal point
        if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
            const numValue = parseFloat(value)
            // Check if value is not negative and not greater than 5
            if (value === '' || (numValue >= 0 && numValue <= 5)) {
                handleChangeActualScore(e)
            }
        }
    }

    const handleScoreFocus = (e) => {
        e.target.select()
    }

    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{ marginBottom: '24px' }}>
                <ArrowBackButton title={isUpdate ? "Edit Calibration" : "Create Calibration"} isTwoSection={true}/>
            </div>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <h5 style={{ 
                    margin: 0,
                    marginBottom: '24px',
                    fontWeight: 600,
                    color: '#1a1a1a',
                    fontSize: '16px'
                }}>
                    Calibration Configuration
                </h5>

                <form>
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        marginBottom: '24px'
                    }}>
                        <div className="mb-4">
                            <label htmlFor="Employee" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Employee <span style={{color: 'red'}}>*</span>
                            </label>
                            <Select
                                showSearch={true}
                                allowClear
                                size="large"
                                style={{
                                    width: '100%'
                                }}
                                name="Employee"
                                options={employeeSelect}
                                placeholder="Select Employee"
                                onChange={handleSelectedEmployee}
                                value={employee}
                                fontSize="16px"
                            />
                        </div>
                    </div>

                    <h6 style={{ 
                        margin: 0,
                        marginBottom: '16px',
                        fontWeight: 600,
                        color: '#1a1a1a',
                        fontSize: '16px'
                    }}>
                        Employee Score Data
                    </h6>
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        marginBottom: '24px'
                    }}>
                        <div className="flex-row" style={{flexWrap: 'wrap', gap: '16px'}}>
                            <div className="mb-4" style={{width: 'calc(33.3% - 11px)'}}>
                                <label htmlFor="PTTScore" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    PTT Score <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="text" 
                                    inputMode="decimal"
                                    name="PTTScore"
                                    className="form-control" 
                                    id={`ptt-score`} 
                                    placeholder="Enter Score" 
                                    value={actualScore.PTTScore}
                                    onChange={handleScoreInput}
                                    onFocus={handleScoreFocus}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>

                            <div className="mb-4" style={{width: 'calc(33.3% - 11px)'}}>
                                <label htmlFor="PATScore" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    PAT Score <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="text" 
                                    inputMode="decimal"
                                    name="PATScore"
                                    className="form-control" 
                                    id={`pat-score`} 
                                    placeholder="Enter Score" 
                                    value={actualScore.PATScore}
                                    onChange={handleScoreInput}
                                    onFocus={handleScoreFocus}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>

                            <div className="mb-4" style={{width: 'calc(33.3% - 11px)'}}>
                                <label htmlFor="Score360" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Score 360 <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="text" 
                                    inputMode="decimal"
                                    name="Score360"
                                    className="form-control" 
                                    id={`score-360`} 
                                    placeholder="Enter Score" 
                                    value={actualScore.Score360}
                                    onChange={handleScoreInput}
                                    onFocus={handleScoreFocus}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex-row" style={{flexWrap: 'wrap', gap: '16px'}}>
                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="ActualScore" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Actual Score <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="text" 
                                    inputMode="decimal"
                                    name="ActualScore"
                                    className="form-control" 
                                    id={`actual-score`} 
                                    placeholder="Enter Score" 
                                    value={actualScore.ActualScore}
                                    onChange={handleScoreInput}
                                    onFocus={handleScoreFocus}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>

                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="ActualRating" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Actual Rating <span style={{color: 'red'}}>*</span>
                                </label>
                                <Select
                                    allowClear
                                    size="large"
                                    style={{
                                        width: '100%',
                                        height: '46px'
                                    }}
                                    name="ActualRating"
                                    options={ratingChoices}
                                    placeholder="Enter Actual Rating"
                                    onChange={handleDataActualRating}
                                    value={actualScore.ActualRating}
                                    fontSize="16px"
                                />
                            </div>
                        </div>

                        <div className="flex-row" style={{flexWrap: 'wrap', gap: '16px'}}>
                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="Y1Rating" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Previous Rating (Y-1)
                                </label>
                                <Select
                                    allowClear
                                    size="large"
                                    style={{
                                        width: '100%'
                                    }}
                                    name="Y1Rating"
                                    options={ratingChoices}
                                    placeholder="Enter Y1 Rating"
                                    onChange={handleDataY1Rating}
                                    value={actualScore.Y1Rating}
                                    fontSize="16px"
                                />
                            </div>

                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="Y2Rating" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Previous Rating (Y-2)
                                </label>
                                <Select
                                    allowClear
                                    size="large"
                                    style={{
                                        width: '100%'
                                    }}
                                    name="Y2Rating"
                                    options={ratingChoices}
                                    placeholder="Enter Y2 Rating"
                                    onChange={handleDataY2Rating}
                                    value={actualScore.Y2Rating}
                                    fontSize="16px"
                                />
                            </div>
                        </div>
                    </div>
                
                    <h6 style={{ 
                        margin: 0,
                        marginTop: '24px',
                        marginBottom: '16px',
                        fontWeight: 600,
                        color: '#1a1a1a',
                        fontSize: '16px'
                    }}>
                        Calibrator Data
                    </h6>
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        marginBottom: '24px'
                    }}>
                        {
                            Object.keys(payload).length > 0 && projectPhases.length > 0 && projectPhases.map((phase, index) => (   
                                <div key={phase.ID} style={{marginBottom: index < projectPhases.length - 1 ? '24px' : '0'}}>
                                    <p style={{ 
                                        fontWeight: '600', 
                                        color: '#1a1a1a', 
                                        fontSize: '15px',
                                        marginBottom: '12px'
                                    }}>
                                        {phase.Phase.Name}
                                    </p>
                                    <div className="flex-row" style={{flexWrap: 'wrap', gap: '16px', marginLeft: '16px'}}>
                                        <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                            <label htmlFor="Calibrator" style={{ 
                                                fontWeight: '600', 
                                                color: '#374151', 
                                                fontSize: '14px',
                                                marginBottom: '8px',
                                                display: 'block'
                                            }}>
                                                Calibrator
                                            </label>
                                            <Select
                                                showSearch={true}
                                                allowClear
                                                size="large"
                                                style={{
                                                    width: '100%'
                                                }}
                                                name="Calibrator"
                                                options={allUsers}
                                                placeholder="Select Calibrator"
                                                onChange={(value) =>handleData(value, phase.ID, "calibrator")}
                                                value={payload[phase.ID].Calibrator}
                                                fontSize="16px"
                                            />
                                        </div>

                                        <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                            <label htmlFor="SPMO" style={{ 
                                                fontWeight: '600', 
                                                color: '#374151', 
                                                fontSize: '14px',
                                                marginBottom: '8px',
                                                display: 'block'
                                            }}>
                                                SPMO
                                            </label>
                                            <Select
                                                showSearch={true}         
                                                mode="multiple"
                                                allowClear
                                                size="large"
                                                style={{
                                                    width: '100%'
                                                }}
                                                name="SPMO"
                                                options={allSpmo}
                                                placeholder="Select SPMO"
                                                onChange={(value) =>handleData(value, phase.ID, "spmo")}
                                                value={payload[phase.ID].Spmo}
                                                fontSize="16px"
                                            />
                                        </div>
                                    </div>     
                                </div>
                            ))
                        }           
                    </div>

                    <div className="d-flex justify-content-end" style={{marginTop: '24px'}}>
                        { isUpdate ? 
                            <ActionButtonGradient
                                onClick={(e) => onSubmit(e, params.project_id)}
                                variant="primary"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Changes"}
                            />
                            :
                            <ActionButtonGradient
                                onClick={(e) => onSubmit(e, params.project_id)}
                                variant="success"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Calibration"}
                            />
                        }
                    </div>
                </form>
            </div>
            <Tooltip
                id="tooltip-rating-quota"
                style={{ 
                    backgroundColor: "#efefef", 
                    color: "#222", 
                    width: "20rem"
                }}
            />
            </div>
    )
}

export default CalibrationForm